import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";
import ColumnActions from "../molecules/ColumnActions";

import { PlusIcon } from "@heroicons/react/20/solid";
import { InputWithCornerHint } from "../atoms/InputWithCornerHint";
import { t } from "i18next";

type ChatsProps = {
  id: string | number;
  tittle: string;
  state: string;
  typeReaction: string;
};

export type TableListInternalChatsProps = {
  chats: ChatsProps[];
  functionButton: () => void;
};

const TableListInternalChats: React.FC<TableListInternalChatsProps> = ({
  chats,
  functionButton,
}) => {
  return (
    <div className="px-4 sm:px-6 lg:px-8 mt-2">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex w-64"></div>
        <div className="mt-8 sm:ml-auto sm:mt-4 sm:justify-between">
          <button
            onClick={functionButton}
            type="button"
            className="block rounded-full border-2 border-dashed border-gray-400 p-1 text-gray-400 shadow-sm hover:text-gray-500 focus-visible:outline-none"
          >
            <PlusIcon aria-hidden="true" className="h-5 w-5" />
          </button>
        </div>
      </div>

      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full px-3 py-2 align-middle sm:px-6 lg:px-8">
            {chats.length === 0 ? (
              <Empty texto={t("gym.views.no_gyms")} />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                      >
                        {t("posts-master.views.title")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("posts-master.views.state")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("posts-master.views.type_reaction")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {chats.map((chat) => (
                      <tr key={chat.id}>
                        <ColumnText title={chat.tittle} />
                        <ColumnText title={chat.state} />
                        <ColumnText title={chat.typeReaction} />
                        <ColumnActions name={chat.tittle} />
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListInternalChats;
